import { useState } from 'react';
import { Tag, tagIsUnique, updateTag } from '../../../../store/Tags';
import { CircularProgress, Paper, Popper } from '@mui/material';
import { TagColorPicker } from '../../Tagging';
import { useSnackbar } from '../../../../Context/SnackbarContext';

export type TagColorRendererProps = {
  tag: Tag;
};

export function TagColorRenderer({ tag }: TagColorRendererProps) {
  const [open, setOpen] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [ref, setRef] = useState<HTMLButtonElement | null>(null);
  const { setSnack } = useSnackbar();

  const handleColorChange = async (color: string) => {
    if (!tagIsUnique({ ...tag, color })) {
      setSnack({ message: 'Tag with same color already exists', type: 'error', open: true });
      return;
    }
    setUpdating(true);
    const update = { ...tag, color };
    await updateTag(update, true);
    setUpdating(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="flex justify-center items-center align-middle p-2">
      <button
        onClick={() => setOpen(!open)}
        ref={setRef}>
        {!updating && (
          <div
            data-testid="tag-color"
            style={{ backgroundColor: tag.color }}
            className="px-2 py-1 w-12 h-6 rounded-full"></div>
        )}
        {updating && (
          <CircularProgress
            size={24}
            className="text-white"
          />
        )}
      </button>
      <Popper
        open={open}
        anchorEl={ref}>
        <Paper className="p-1">
          <TagColorPicker
            color={tag.color}
            onSubmit={handleColorChange}
            onClose={handleClose}
            showActions
          />
        </Paper>
      </Popper>
    </div>
  );
}
